import React from "react";
import styled from "styled-components";
import { IonSearchbar } from "@ionic/react";
import { useTranslation } from "react-i18next";

import filterIcon from "../../../assets/MentalPlus/filtres.png";
import saveIcon from "../../../assets/MentalPlus/save2.png";

type Props = {
  query: string;
  onQueryChange: (value: string) => void;
  onOpenFilters: () => void;
  onOpenSaved: () => void;
};

const VideoToolbar: React.FC<Props> = ({
  query,
  onQueryChange,
  onOpenFilters,
  onOpenSaved,
}) => {
  const { t } = useTranslation();

  return (
    <TopBar>
      <BarRow>
        <SquareAction onClick={onOpenFilters}>
          <img className="iconImg" src={filterIcon} alt="" />
          <span className="label">{t("mentalplus_video_filtres")}</span>
        </SquareAction>

        <SearchField>
          <IonSearchbar
            value={query}
            placeholder={t("mentalplus_video_rechercher")}
            inputmode="search"
            debounce={200}
            onIonInput={(e) => onQueryChange(e.detail.value ?? "")}
            showClearButton="focus"
            showCancelButton="never"
          />
        </SearchField>

        <SquareAction onClick={onOpenSaved}>
          <img className="iconImg" src={saveIcon} alt="" />
          <span className="label">{t("mentalplus_video_enregistrees")}</span>
        </SquareAction>
      </BarRow>
    </TopBar>
  );
};

export default VideoToolbar;

const TopBar = styled.div`
  background: white;
  padding: 0 8px;
`;

const BarRow = styled.div`
  display: flex;
  align-items: stretch;
  gap: 10px;
  padding-top: 4px;
  padding-bottom: 8px;
  background: white;
`;

const SquareAction = styled.button`
  flex: 0 0 auto;
  width: 74px;
  height: 58px;
  border: none;
  border-radius: 14px;
  background: #ffce48;
  color: #1b1b1b;
  cursor: pointer;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;

  .label {
    font-size: 12px;
    line-height: 12px;
    font-weight: 600;
    white-space: nowrap;
  }

  .iconImg {
    width: 22px;
    height: 22px;
    object-fit: contain;
    display: block;
  }

  @media (max-width: 420px) {
    width: 62px;
    height: 54px;

    .label {
      font-size: 11px;
    }

    .iconImg {
      width: 20px;
      height: 20px;
    }
  }

  @media (max-width: 360px) {
    width: 54px;

    .label {
      display: none;
    }
  }
`;

const SearchField = styled.div`
  flex: 1;
  min-width: 0;
  height: 58px;
  border-radius: 16px;
  background: white;

  display: flex;
  align-items: center;
  padding: 0 6px;

  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);

  ion-searchbar {
    width: 100%;
    padding: 0;
    --background: transparent;
    --box-shadow: none;
    --border-radius: 16px;
    --color: #1b1b1b;
    --placeholder-color: #9a9a9a;
    --icon-color: #1b1b1b;
    --clear-button-color: #1b1b1b;
    --height: 58px;
  }
`;